<form class="card card-radius m-0 relative" [formGroup]="form" (submit)="handleFormSubmit($event)">
  <button class="close-btn" aria-label="close" tabindex="-1" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>

  @if (!emailSent) {
    <h2 class="text-xxl text-bold text-center mb-5">{{ 'forgot_password.title' | transloco }}</h2>
    <div class="mb-5">
      <label class="form-label" for="email">{{ 'global.form.field.email' | transloco }}</label>
      <input class="form-control mb-3" type="email" id="email" formControlName="email" required />
      @if (hasError('email', 'email')) {
        <span class="form-error">{{ 'errors.email' | transloco }}</span>
      }
      @if (emailInvalid) {
        <span class="form-error">{{ 'errors.forgot_email_invalid' | transloco }}</span>
      }
      <p class="text-md">
        {{ 'forgot_password.description' | transloco }}
      </p>
    </div>
    <button class="btn btn-primary w-100 mb-3" type="submit" tabindex="0" [disabled]="form.invalid">
      {{ 'global.continue' | transloco }}
    </button>
  } @else {
    <h2 class="text-xxl text-bold text-center mb-5">
      {{ 'forgot_password.check_your_email' | transloco }}
    </h2>
    <p class="text-md text-center mb-5">{{ 'forgot_password.success_message' | transloco }}</p>
  }
</form>
